module.exports = __webpack_public_path__ + "static/for_whom_bg_middle-b21b7419034f3abbb815e9a2359db2a8.png";